import { useTranslation } from 'react-i18next'

import { getLang, setLang, type Lang } from '@/i18n'

import styles from './langToggle.module.scss'

export interface LangToggleProps {
  className?: string
}

const OPTIONS: readonly { lang: Lang; label: string }[] = [
  { lang: 'pl', label: 'common.langPl' },
  { lang: 'en', label: 'common.langEn' },
]

export default function LangToggle({ className }: LangToggleProps) {
  // `useTranslation` re-renders on `languageChanged`, so `getLang()` is always fresh.
  const { t } = useTranslation()
  const current = getLang()

  return (
    <div
      className={className ? `${styles.pill} ${className}` : styles.pill}
      role='group'
    >
      {OPTIONS.map((option) => (
        <button
          key={option.lang}
          type='button'
          lang={option.lang}
          aria-pressed={current === option.lang}
          className={current === option.lang ? `${styles.seg} ${styles.active}` : styles.seg}
          onClick={() => {
            if (current !== option.lang) setLang(option.lang)
          }}
        >
          {t(option.label)}
        </button>
      ))}
    </div>
  )
}
